import React from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';

const DeclinePage = () => (
  <Content>
    {({
      declinePageTitle = '',
      declineContentA,
      declineContentB,
      declineContentC,
      declineContentCUrl,
      declineContentE,
      declineContentEUrl,
      browserNewWindow
    }) => (
      <div>
        <PageHeading>{declinePageTitle}</PageHeading>
        <StandardBody>
          <p>{declineContentA}</p>
          <p>{declineContentB}</p>
        </StandardBody>
        <BulletList
          items={[
            <WebsiteLink
              url={declineContentCUrl}
              linkTitle={browserNewWindow}
              linkText={declineContentC}
              willOpenNewWindow
            />,
            <WebsiteLink
              url={declineContentEUrl}
              linkTitle={browserNewWindow}
              linkText={declineContentE}
              willOpenNewWindow
            />
          ]}
        />
      </div>
    )}
  </Content>
);

DeclinePage.propTypes = {
  bankId: PropTypes.bankId.isRequired
};

export default DeclinePage;
